module.exports = __webpack_public_path__ + "media/success.8a383acc.wav";